"use client";

import { usePathname } from "next/navigation";
import classNames from "classnames";

import { Wrapper } from "@/components/Wrapper";
import { QRPreview } from "@/components/QRPreview";
import { QREditorFooter } from "@/components/QREditorFooter";

import { QREditorLayoutTemplateProps } from "./types";

import { isValidQRSlug } from "@/utils/qrSlug";
import { usePrefetchRouter } from "@/hooks/navigation/usePrefetchRouter";
import { PATHS } from "@/internals/constants/paths";
import { TranslationsProvider } from "@/hocs/TranslationsProvider";

import "./styles.scss";

export const QREditorLayoutTemplate = (props: QREditorLayoutTemplateProps) => {
  const { data, language, resources, namespaces, children } = props;
  const pathname = usePathname();
  const isRegister = () => pathname?.includes("/register");

  const getSlugParam = pathname?.split("/").pop();
  const isQrSlug = isValidQRSlug(getSlugParam);

  if (isQrSlug) {
    usePrefetchRouter([`${PATHS.QR_EDITOR}/${getSlugParam}${PATHS.DESIGN}`]);
  }
  const isDesign = pathname?.includes(PATHS.DESIGN);
  if (isDesign) {
    usePrefetchRouter([PATHS.SIGNUP]);
  }

  const { customClass } = data;
  const classnames = classNames(`qr-editor-layout`, {
    [`${customClass}`]: customClass,
  });

  return (
    <TranslationsProvider
      namespaces={namespaces}
      locale={language}
      resources={resources}
    >
      <div className={classnames}>
        <Wrapper customClass="EditorLayout__wrapper">
          <div className="EditorLayout__container">
            <div className="EditorLayout__form">{children}</div>
            <div className="EditorLayout__preview">
              <QRPreview
                previewTranslations={props.data.previewTranslations}
                previewHome={props.data.previewSelector}
                previewButtonsTranslations={props.data.previewButtonsTranslations}
                language={props.language}
                modalData={props.data.modalData}
                defaultPreviewTitle={props.data.defaultPreviewTitle}
              />
            </div>
          </div>
          {!isRegister() && (
            <QREditorFooter
              data={data}
              defaultPreviewTitle={data.defaultPreviewTitle}
            />
          )}
        </Wrapper>
      </div>
    </TranslationsProvider>
  );
};
